module.exports = __webpack_public_path__ + "static/reduction180-74022ba35e5bf711e2ae1abc61ef04de.svg";